import { useTranslation } from "react-i18next";
import { useCategoryStore } from "@/stores/use-tutorial-progress";
import PlaylistCompleted from "./playlist-completed";
import { isSpecialTagSelected } from "@/utils/isSpecialTagSelected";

interface CourseProgressBarProps {
  progress: number;
  courseName?: string;
  completedLessons?: number;
  totalLessons?: number;
  showIcon?: boolean;
  variant?: "default" | "gradient" | "animated";
}

export const CourseProgressBar = ({
  isExpanded,
  setIsExpanded,
  isLargeScreen,
  tagPreferences,
}) => {
  const { t } = useTranslation();
  const {
    currentSelection,
    getCompletedTutorialCountByPlaylist,
    getTutorialCountByPlaylist,
  } = useCategoryStore();
  const totalTutorials = getTutorialCountByPlaylist(
    currentSelection?.playlist.documentId
  );
  const currentProgress = getCompletedTutorialCountByPlaylist(
    currentSelection?.playlist.documentId
  );
  // const clampedProgress = !progress ? 0 : Math.min(Math.max(progress, 0), 100);

  const handleClick = () => {
    if (!isLargeScreen) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <>
      <div
        className={`sticky top-14 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 ${
          !currentSelection ? "lg:hidden" : ""
        }`}
      >
        <div className="max-w-4xl mx-auto px-0 py-2 lg:px-1">
          <div className="flex items-center justify-between mb-2">
            <div className="flex justify-between items-center gap-2 min-w-0 flex-1 px-2">
              {!isSpecialTagSelected(tagPreferences.included) && (
                <span
                  onClick={handleClick}
                  className="text-xs md:text-lg text-gray-400 dark:text-gray-300 text-md bg-gray-900/[0.08] dark:bg-blue-500 py-1 px-2.5 rounded-full lg:bg-transparent lg:py-0 lg:px-2 flex items-center"
                >
                  {currentSelection ? (
                    <>
                      {currentSelection.category.title} /&nbsp;
                      <strong className="text-black dark:text-white font-medium">
                        {currentSelection.playlist.title}
                      </strong>
                      {!isLargeScreen && (
                        <svg
                          className={`w-4 h-4 text-gray-400 dark:text-gray-300 transition-transform duration-200 ml-1 ${
                            isExpanded ? "rotate-180" : "rotate-0"
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      )}
                    </>
                  ) : (
                    <strong className="text-black dark:text-white font-medium lg:hidden">
                      {t("common.selectCategory")}
                    </strong>
                  )}
                </span>
              )}

              {currentSelection && (
                <span className="text-gray-400 dark:text-gray-300 text-xs md:text-md font-bold  bg-gray-900/[0.08] dark:bg-white/[0.05] py-1 px-2.5 rounded-full">
                  {currentProgress} / {totalTutorials}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {currentProgress !== 0 &&
        currentProgress === totalTutorials &&
        !isExpanded && <PlaylistCompleted />}
    </>
  );
};
